// Порт client_app/src/stores/authStore/service.ts.
// Все эндпоинты — те же, что у мобильного приложения.

import { api } from '../../api/instance';

export const authService = {
  getOrUpdateToken(token, nullifyPush) {
    const body = {};
    if (token) body.token = token;
    if (nullifyPush !== undefined) body.nullify_push = nullifyPush;
    return api.post('v3/tokens', body);
  },
  setCity(cityBranchId) {
    return api.post('v3/tokens/city', { city_id: cityBranchId });
  },
  setLang(lang) {
    return api.post('v3/tokens/lang', { lang });
  },
  sendSmsCode(phone) {
    return api.post('v3/tokens/send_code', { phone });
  },
  submitSmsCode(code) {
    return api.post('v3/tokens/submit_code', { code });
  },
  submitPhoneForCall(phone) {
    return api.post('v3/tokens/submit_phone', { phone });
  },
  loginByEmail(email, password) {
    return api.post('v3/tokens/login_by_email', { email, password });
  },
  registerByEmail(payload) {
    return api.post('v3/tokens/register_by_email', payload);
  },
  emailRecovery(email) {
    return api.post('v3/tokens/email_recovery', { email });
  },
  logout() {
    return api.del('v3/tokens/logout');
  },
  createCoupledToken() {
    return api.post('v3/tokens/create_coupled', {});
  },
  updateClientInfo(clientInfo) {
    return api.post('v3/settings', { client_info: clientInfo });
  },
  updateAvatar(file) {
    const fd = new FormData();
    fd.append('avatar', file);
    return api.postForm('v3/settings/avatar', fd);
  },
  removeAvatar() {
    return api.post('v3/settings/avatar', { avatar_remove: true });
  },
};



// WEBPACK FOOTER //
// ./app/javascript/website_newgen/js/stores/authStore/service.js